import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Row, } from 'antd';
import { CloseOutlined, DoubleRightOutlined, RollbackOutlined } from '@ant-design/icons';
import { GetById_FoodPricePeriod_Api } from '../../API/FoodPricePeriodApi';
import { GetAll_Food_Api } from '../../API/FoodApi';
import { GetAll_FoodPrice_Api } from '../../API/FoodPriceApi';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import { EditFoodPricesDetailsComponent } from './EditFoodPricesDetailsComponent';

export const EditFoodPricesComponent = ({ setLoading,
    showMessage,
    foodPricePeriodId,
    onCompleteEdit }) => {
    // =================================================================
    const [foodPricePeriod, setFoodPricePeriod] = useState();
    const [foods, setFoods] = useState();
    const [foodPrices, setFoodPrices] = useState();
    const [form] = Form.useForm();
    // =================================================================
    useEffect(() => {
        setFoodPricePeriod(null);
        loadFoodPricePeriod();
        loadFoods();
        loadFoodPrices();
    }, [foodPricePeriodId]);
    // =================================================================
    const loadFoodPricePeriod = async () => {
        setLoading(true);
        try {
            const data = await GetById_FoodPricePeriod_Api(foodPricePeriodId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                console.log("data.messageData.data", data.messageData.data)
                setFoodPricePeriod(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const loadFoods = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Food_Api();
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setFoods(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const loadFoodPrices = async () => {
        setLoading(true);
        try {
            const data = await GetAll_FoodPrice_Api(foodPricePeriodId);

            //   form.setFoodsValue(data.messageData.data[0])
            setLoading(false);
            if (data.messageStatus == "Successful") {
                console.log("foodprice", data.messageData.data)
                setFoodPrices(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    return (
        <>
            {foodPricePeriod ? (
                <>
                    <Row className='sectionTitle'>
                        <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                            <Button onClick={() => onCompleteEdit()}>
                                <DoubleRightOutlined />
                                بازگشت
                            </Button>
                        </Col>
                        <Col xs={10} sm={10} md={10} lg={14} xl={14}>
                            <h2 >
                                {foodPricePeriod.title}
                            </h2>
                        </Col>
                        <Col xs={10} sm={10} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                        </Col>

                    </Row>
                    <div className='container'>
                        {foods?.map((food) =>
                            <>
                                <div className="valueRow" key={food.id}>
                                    <EditFoodPricesDetailsComponent
                                        setLoading={setLoading}
                                        showMessage={showMessage}

                                        foodPriceValues={{
                                            "foodId": '' + food.id,
                                            "foodTitle": food.title,
                                            "price": '' + foodPrices?.filter(fv => fv.foodId === food.id)[0]?.price,
                                            "id": '' + foodPrices?.filter(fv => fv.foodId === food.id)[0]?.id,
                                            "foodPricePeriodId": '' + foodPricePeriod.id,
                                            "foodPricePeriodTitle": foodPricePeriod.title,
                                        }}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </>
            ) : (<>
            </>)
            }

        </>
    )

}
